import { observer } from "mobx-react-lite";
import React from "react";
import {
  HelperType,
  type HelpItem,
  HelpItemRequiredType,
} from "../../../helper/HelperManager";
import { useHelper } from "../../../helper/useHelper";
import type ExpenseModuleModel from "../ExpenseModuleModel";

export const ExpenseHelper: React.FC<{ module: ExpenseModuleModel }> = observer(
  ({ module }) => {
    const items: HelpItem[] = React.useMemo(
      () => [
        {
          type: HelpItemRequiredType.Required,
          label: "Add an expense",
          isCompleted: () => {
            return module.expenses.length > 0;
          },
        },
        {
          type: HelpItemRequiredType.Tip,
          label: "You can settle up at any time",
          isEnabled: () => {
            return !module.settlements.length;
          },
          isCompleted: () => {
            return false;
          },
        },
      ],
      [module],
    );

    const helper = useHelper(module.uid, HelperType.Poll, items);

    return helper;
  },
);
